import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Button } from "antd";
import Header from "../../components/Header/Header";
import useAuthStore from "../../stores/useAuthStore";
import { logout as authLogout } from "../../auth";
import { useTranslation } from "react-i18next";
import "./NotFound.css";

const NOTFOUND_IMAGE = "/assets/images/404-149.png";

const { Content } = Layout;

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("notFound");
  const userData = useAuthStore((s) => s.userData);
  const setPageTitle = useAuthStore((s) => s.setPageTitle);

  useEffect(() => {
    setPageTitle(t("page_name"));
  }, [t, setPageTitle]);

  const logout = () => {
    const { redirectPath } = authLogout();
    navigate(redirectPath);
  };

  const isDashboardUser =
    userData?.role === "admin" || userData?.role === "owner" || userData?.role === "user";

  const handlePrimaryClick = () => {
    if (isDashboardUser) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  };

  return (
    <Layout style={{ height: "100%" }}>
      {isDashboardUser ? <Header onLogout={logout} type="dashboard" /> : null}

      <Layout className="notfound-layout">
        <Content
          className="notfound-content"
          style={{
            padding: 0,
            flex: 1,
            minHeight: "calc(100vh - 82px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="notfound-page">
            <div className="notfound-sparkles" aria-hidden>
              {[
                { c: "teal", x: 12, y: 18 },
                { c: "blue", x: 88, y: 22 },
                { c: "orange", x: 24, y: 72 },
                { c: "teal", x: 76, y: 68 },
                { c: "orange", x: 52, y: 14 },
                { c: "blue", x: 14, y: 48 },
                { c: "teal", x: 92, y: 54 },
                { c: "orange", x: 68, y: 82 },
                { c: "blue", x: 38, y: 28 },
                { c: "teal", x: 62, y: 42 },
              ].map(({ c, x, y }, i) => (
                <span
                  key={i}
                  className={`notfound-sparkle notfound-sparkle--${c}`}
                  style={{ left: `${x}%`, top: `${y}%`, animationDelay: `${i * 0.25}s` }}
                />
              ))}
            </div>
            <div className="notfound-hero">
              <img
                src={NOTFOUND_IMAGE}
                alt={t("title")}
                className="notfound-graphic"
              />
              <div className="notfound-kicker">{t("kicker")}</div>
              <h1 className="notfound-title">{t("title")}</h1>
              <div className="notfound-actions">
                <Button type="primary" onClick={handlePrimaryClick}>
                  {isDashboardUser ? t("button.go_dashboard") : t("button.go_login")}
                </Button>
                {window.history.length > 1 && (
                  <button
                    type="button"
                    className="notfound-back"
                    onClick={() => navigate(-1)}
                  >
                    {t("button.go_back")}
                  </button>
                )}
              </div>
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default NotFound;